module.exports = __webpack_public_path__ + "img/2.388fc574.png";